// extracted by mini-css-extract-plugin
export default {"priminent-skill":"styles_priminent-skill__1kS8A","priminentSkill":"styles_priminent-skill__1kS8A"};